module.exports = __webpack_public_path__ + "static/media/67_tn.f9729957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/67_tn.jpg
// module id = 554
// module chunks = 0